//Obtiene el mensaje elegido con el código desde el localstorage
export const getMessage = (cod) => {
    const messages = JSON.parse(localStorage.getItem('Messages'))

    const message = messages?.find(msj => msj.TiposMensajesCodigoInternoId === cod)

    if(message) {
        return message.MensajesDescripcion
    } else {
        return ''
    }
    
}
